<template>
    <div class="contain">
        <img class="imgs" src="../../../assets/c22/guide01.png" alt="솔닥서포터즈 1기 절찬 모집중 (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c22/guide02.png" alt="솔닥서포터즈 1기 절찬 모집중 (다음 내용 참조)" ref="secondImage" />
        <img class="imgs" src="../../../assets/c22/guide03.png" alt="솔닥서포터즈 1기 절찬 모집중 (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c22/guide04.png" alt="" />
        <div class="sr-only">
            <h1>soldoc+</h1>
            <h2>솔닥서포터즈 1기 절찬 모집중</h2>
            <span>24.06.24 ~ 24.06.28</span>
            <div>
                <span>SNS에 자신있는 분이라면 주목!</span>
                <strong>3주간 총 활동비 30만원의 기회를 놓치지 마세요</strong>
            </div>
            <div>
                <h3><span>모집 대상</span> 이런 분들을 모셔요</h3>
                <ul>
                    <li>#20인모집</li>
                    <li>#활동비30만원</li>
                </ul>
                <ul>
                    <li>블로그, 인스타그램을 활발히 운영하고 있어요</li>
                    <li>솔닥 서비스를 만족스럽게 이용 중이에요</li>
                    <li>솔닥 서비스를 다른 사람들과 나누고 싶어요</li>
                    <li>서포터즈 활동에 성실히 참여하고, 모든 활동 지원금을 받아가고 싶은 열정이 있어요</li>
                </ul>

                <h3><span>활동 내용</span> 이런 활동을 담당하게 되어요</h3>
                <ul>
                    <li>매주 블로그, 인스타그램 미션을 수행해요</li>
                    <li>소문내기, 릴스 등 추가미션을 수행하면 더욱 풍성항 활동비를 얻어갈 수 있어요</li>
                </ul>
                <p>* 자세한 활동 내용은 선정자에 한하여 추후 공개됩니다</p>

                <h3><span>모집 및 활동기간</span> 총 3주간 멋진 서포터즈로 함께해주세요!</h3>
                <ul>
                    <li>모집 기간 : 2024.06.24 ~ 2024.06.28</li>
                    <li>선정 발표 : 2024.07.01</li>
                    <li>활동 기간 : 2024.07.08 ~ 2024.07.27</li>
                </ul>
                <p>* 선정 발표는 선정자에 한하여 개별 통보됨을 알립니다</p>
                <p>* 기간은 당사 사정에 의해 조정될 수 있습니다</p>

                <h3><span>유의사항</span> 꼭 확인하세요!</h3>
                <p>* 1인당 1회 신청 가능하며, 중복 신청 및 참여는 인정되지 않습니다.</p>
                <p>* 자세한 미션 활동은 선정 발표 시 추가 안내 예정입니다.</p>
                <p>* 선정자는 일주일 이내 서포터즈 단톡방에 초대되어 미션 기간동안 단톡방에서 활동하게 될 예정입니다.</p>
            </div>
        </div>

        <a href="https://forms.gle/taMstrWdqJRie4Sy8" target="_blank" title="새 창" :class="['c22-floot-cta', { 'scrolled': isScrolled }]">
            <img class="imgs" src="../../../assets/c22/cta-btn.png" alt="서포터즈 신청하러 가기 (활동비 30만원의 기회 놓치지 마세요)" />
        </a>
    </div>
</template>

<script>
export default {
    name: "c22",
    data() {
        return {
            isScrolled: false
        };
    },
    methods: {
        handleScroll() {
            const secondImage = this.$refs.secondImage;
            const rect = secondImage.getBoundingClientRect();
            this.isScrolled = rect.top <= window.innerHeight - 410;
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>

<style scoped>
    .contain {
        width: 100%;
        max-width: 800px;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        margin: 0 auto;
        overflow: hidden;
    }   
    .contain .imgs {
        width: 100%;
    }
    .contain .sr-only {
        position: absolute;
        left: -9999px;
        width: 1px;
        height: 1px;
        margin: 0 !important;
        font-size: 0;
        line-height: 0;
        overflow: hidden;
    }
    .c22-floot-cta {
        position: fixed;
        bottom: 60px;
        left: calc(50% - 357px);
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.5s ease;
    }
    .c22-floot-cta.scrolled {
        visibility: visible;
        opacity: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c22.vue